import { create } from "zustand";
import { formatRecordTime } from "@/utils/formatter";

// 显示状态、音频视频播放共用进度状态
interface VideoPlayerState {
  windowType: "foot" | "fullScreen" | "popUp",
  videoRef: HTMLVideoElement | null,
  isPlaying: boolean, // 是否正在播放
  volume: number,
  totalTime: string, // 总时长
  totalDuration: number,
  elapsedTime: string, // 已经播放的时间
  elapsedDuration: number,
  playbackRate: number, // 播放速度
  rateText: string, // 播放速度显示文本
  isSliderChanging: boolean, // 是否正在拖拽进度
  videoLoaded: boolean;
}

interface VideoPlayerStore extends VideoPlayerState {
  changeType: (value: "foot" | "fullScreen" | "popUp") => void;
  setPlayer: (player: HTMLVideoElement | null) => void;
  setTotalTime: (seconds: number) => void;
  onProgress: (value: {
    // played: number,
    playedSeconds: number,
    // loaded: number,
    // loadedSeconds: number
  }) => void;
  onReady: () => void;
  play: () => void;
  pause: () => void;
  changeSpeed: (rate: string) => void;
  changeSchedule: (time: number, isSeek: boolean) => void;
  forwardPlay: (seconds: number) => void;
  backPlay: (seconds: number) => void;
  endPlay: () => void;
  checkPlayStatus: () => void;
  reload: () => void;
  reset: () => void;
  setVideoLoaded: (videoLoaded: boolean) => void;
}

const videoPlayerState: VideoPlayerState = {
  windowType: "foot",
  videoRef: null,
  isPlaying: false,
  volume: 1,
  totalTime: "00:00",
  totalDuration: 0,
  elapsedTime: "00:00",
  elapsedDuration: 0,
  playbackRate: 1.0,
  rateText: "1.0",
  isSliderChanging: false,
  videoLoaded: false
}

const videoPlayerStore = create<VideoPlayerStore>((set, get) => ({
  ...videoPlayerState,
  changeType: (value) => {
    set({ windowType: value });
  },
  setPlayer: (value) => {
    console.log('setPlayer = ', value);
    set({ videoRef: value });
  },
  setTotalTime: (value) => {
    set({ totalTime: formatRecordTime(value), totalDuration: value });
  },
  onReady: () => {
    // get().changeSchedule(0.1, true);
  },
  play: () => {
    const ref = get().videoRef;
    ref?.play();
    set({ isPlaying: true });
  },
  pause: () => {
    const ref = get().videoRef;
    ref?.pause();
    set({ isPlaying: false });
  },
  onProgress: (value) => {
    if (get().isSliderChanging) return;
    set({
      elapsedTime: formatRecordTime(value.playedSeconds),
      elapsedDuration: value.playedSeconds
    });
  },
  changeSpeed: (rate: string) => {
    const ref = get().videoRef;
    ref && (ref.playbackRate = Number(rate));
    set({ playbackRate: Number(rate), rateText: rate });
  },
  changeSchedule: (time: number, isSeek: boolean) => {
    const ref = get().videoRef;
    if (!ref) return;
    set({
      elapsedTime: formatRecordTime(time),
      elapsedDuration: time,
      isSliderChanging: !isSeek
    });
    if (isSeek) {
      ref.currentTime = (time);
    }
  },
  forwardPlay: (value) => {
    const ref = get().videoRef;
    if (!ref) return;
    const elapsedDuration = get().elapsedDuration;
    const totalDuration = get().totalDuration;
    ref.currentTime = (elapsedDuration + value >= totalDuration ? totalDuration : elapsedDuration + value);
  },
  backPlay: (value) => {
    const ref = get().videoRef;
    if (!ref) return;
    const elapsedDuration = get().elapsedDuration;
    ref.currentTime = (elapsedDuration - value <= 0 ? 0 : elapsedDuration - value);
  },
  endPlay: () => {
    set({ isPlaying: false });
  },
  checkPlayStatus: () => {
    const ref = get().videoRef;
    if (!ref) return;
    const isPlaying = get().isPlaying;
    if (!isPlaying) {
      ref.pause();
    }
  },
  reload: () => {
    const ref = get().videoRef;
    if (!ref) return;
    ref.play();
  },
  reset: () => {
    set({ ...videoPlayerState });
  },
  setVideoLoaded: (videoLoaded: boolean) => {
    set({ videoLoaded });
  }
}));

export default videoPlayerStore;